export const MODULE_ID = "crlngn-ui";
export const MODULE_TITLE = "Carolingian UI";
export const MODULE_SHORT = "crlngn-ui";
export const DEBUG_TAG = [
  `%cCarolingian UI`,
  `color:rgb(123, 77, 179); font-weight: bold;`,
  `|`,
];

export const ROLL_TYPES = {
  abilityCheck: "ability",
  abilitySave: "save",
  attack: "attack",
  check: "check",
  concentration: "concentration",
  damage: "damage",
  deathSave: "death",
  formula: "formula",
  healing: "heal",
  custom: "roll",
  skillCheck: "skill",
  toolCheck: "tool"
}

export const CHAR_ABILITIES = [
  { abbrev: "str", name: "strength" },
  { abbrev: "dex", name: "dexterity" },
  { abbrev: "con", name: "constitution" },
  { abbrev: "int", name: "intelligence" },
  { abbrev: "wis", name: "wisdom" },
  { abbrev: "cha", name: "charisma" }
]

export const CLASS_PREFIX = 'crlngn';